import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
  meta: {
    total: 0,
    page: 1,
    per_page: 25,
  },
  unreadCount: 0,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
